export default "__VITE_ASSET__BAG76HiM__"